import { copy } from './object-differ'
import * as menuSections from './empty-menu-sections'

export function getCategoryStyles (department) {
  let styles = {
    entityType: 'DEPARTMENT_CATEGORY_STYLES',
    defaults: [],
    disabled: []
  }

  if (!department.hasOwnProperty('styles')) {
    return styles
  }

  department.styles.forEach(style => {
    let defaultOption = style.options.find(next => next.default)
    if (defaultOption) {
      styles.defaults.push({
        entityType: 'MENU_STYLES_DEFAULT',
        $identifier: 'optionId',
        styleId: style.id,
        optionId: defaultOption.id
      })
    }
  })

  return styles
}

export function getCategoryTaxes (department) {
  return {
    ...copy(department.hasOwnProperty('taxes') ? department.taxes : menuSections.departmentTaxes()),
    entityType: 'DEPARTMENT_CATEGORY_TAXES'
  }
}

export function getCategoryPrinting (department) {
  return {
    ...copy(department.hasOwnProperty('printing') ? department.printing : menuSections.departmentPrinting()),
    entityType: 'DEPARTMENT_CATEGORY_PRINTING'
  }
}

export function getCategoryKPS (department) {
  return {
    ...copy(department.hasOwnProperty('kps') ? department.kps : menuSections.departmentKPS()),
    entityType: 'DEPARTMENT_CATEGORY_KPS'
  }
}

export function getItemStyles (category, department) {
  return {
    ...category.hasOwnProperty('styles') ? copy(category.styles) : getCategoryStyles(department),
    entityType: 'DEPARTMENT_ITEM_STYLES'
  }
}

export function getItemPricing (category) {
  if (category.hasOwnProperty('pricing')) {
    let pricing = copy(category.pricing)
    pricing.forEach(next => { next.entityType = 'DEPARTMENT_ITEM_PRICING' })
    return pricing
  } else {
    return []
  }
}

export function getItemTaxes (category, department) {
  return {
    ...category.hasOwnProperty('taxes') ? copy(category.taxes) : getCategoryTaxes(department),
    entityType: 'DEPARTMENT_ITEM_TAXES'
  }
}

export function getItemPrinting (category, department) {
  return {
    ...category.hasOwnProperty('printing') ? copy(category.printing) : getCategoryPrinting(department),
    entityType: 'DEPARTMENT_ITEM_PRINTING'
  }
}

export function getItemKPS (category, department) {
  return {
    ...category.hasOwnProperty('kps') ? copy(category.kps) : getCategoryKPS(department),
    entityType: 'DEPARTMENT_ITEM_KPS'
  }
}

export function getItemInclusions (category) {
  return {
    ...copy(category.hasOwnProperty('inclusions') ? category.inclusions : menuSections.departmentCategoryInclusions()),
    entityType: 'DEPARTMENT_ITEM_INCLUSIONS'
  }
}

export function getItemRequirements (category) {
  if (category.hasOwnProperty('requirements')) {
    let requirements = copy(category.requirements)
    return requirements.map(next => { return { ...next, entityType: 'DEPARTMENT_ITEM_REQUIREMENT' } })
  } else {
    return []
  }
}

export function getItemSuggestions (category) {
  return {
    ...copy(category.hasOwnProperty('suggestions') ? category.suggestions : menuSections.departmentCategorySuggestions()),
    entityType: 'DEPARTMENT_ITEM_SUGGESTIONS'
  }
}

export function getModifierItemPrinting (category) {
  return {
    ...copy(category.hasOwnProperty('printing') ? category.printing : menuSections.modifierCategoryPrinting()),
    entityType: 'MODIFIER_ITEM_PRINTING'
  }
}
